export function nextBalance(before, delta, allowNegative = false) {
  if (!Number.isFinite(before) || !Number.isFinite(delta)) throw new Error("Quantidade inválida.");
  const after = before + delta;
  if (!allowNegative && after < 0) throw new Error(`Estoque insuficiente. Disponível: ${before}.`);
  return after;
}

export function transferBalances(source, destination, quantity, allowNegative = false) {
  if (!Number.isFinite(quantity) || quantity <= 0) throw new Error("Informe uma quantidade válida para transferir.");
  return {
    source: nextBalance(source, -quantity, allowNegative),
    destination: nextBalance(destination, quantity, true),
    totalBefore: source + destination,
    totalAfter: source - quantity + destination + quantity,
  };
}
